import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Saurav Chemudu</h2>
        <p><a href="mailto:schemudu@outlook.com">schemudu@outlook.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>
        <p>
          I&apos;m a software engineer focused on data engineering and low-code development.
          I build cloud-based data pipelines that turn messy, scattered data into clean,
          analytics-ready insights, and I design low-code applications that streamline
          business workflows.
        </p>
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Saurav Chemudu <Link to="/">schemudu.com</Link>.</p>
    </section>
  </section>
);

export default SideBar;
